/* Scoped navigation support; no ShowTime components or commerce state. */
document.querySelectorAll('[data-club-search]').forEach(search => {
  const close = () => { search.open = false; search.querySelector('summary').focus(); };
  search.querySelector('[data-club-search-close]').addEventListener('click', close);
  search.addEventListener('keydown', event => { if (event.key === 'Escape') close(); });
  search.addEventListener('toggle', () => { if (search.open) search.querySelector('input').focus(); });
});
